import AnchorContainer from '../Anchor/AnchorContainer';

function AnchorPage() {
  return <AnchorContainer />;
}

export default AnchorPage;
